<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
<!-- <div calss="form-group row">
    <div class="col-md-6">
        <h1>REKAPITULACIJA - opis</h1>            
    </div>    
        </div>   -->
        <div class="form-group row">  
                <div class="col-md-6">
                    <yt-multiselect
                        [ModelName]="'orgjed'"
                        [GetName]="'getParentAndChildByParentID'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        formControlName="OrgJed"
                        [AllowAddNew]="false" 
                        [Type]="'ID'"
                        [Label]="'REKAPITULACIJA.ORGJED.SINGULAR'"                
                        [ngClass]="{'is-invalid': submitted && fc.OrgJed.invalid}"
                    >
                    </yt-multiselect>
                </div>
                <!-- <div class="col-md-6">
                        <yt-multiselect
                            [ModelName]="'orgjed'"
                            [GetName]="'getParentAndChildByParentID'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            formControlName="OrgJed"
                            [Type]="'ID'"
                            [Label]="'REKAPITULACIJA.VRSTADOKUMENTA.SINGULAR'"                
                            [ngClass]="{'is-invalid': submitted && fc.OrgJed.invalid}"
                        >
                        </yt-multiselect>
                    </div> -->
            </div> 
    <div class="form-group row">
        <div class="col-md-3">
            <yt-fw-date-picker-popup
                name="txtOdDatuma"
                formControlName="OdDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                [Label]="'REKAPITULACIJATROSKOVA.ODDATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                <span *ngFor="let validation of errorMessages.OdDatuma">
                    <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-3">
            <yt-fw-date-picker-popup
                name="txtDoDatuma"
                formControlName="DoDatuma"
                [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                [Label]="'REKAPITULACIJATROSKOVA.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-6">
            <yt-multiselect
                          [ModelName]="'komitent'"
                          [GetName]="'get'"
                          [ModelProperty]="'SNaziv'"
                          [OrderBy]="'SNaziv'"
                          formControlName="KomitentID"
                          [AllowAddNew]="false" 
                          [Type]="'ID'"
                          [Label]="'REKAPITULACIJA.KOMITENTNAZIV.SINGULAR'"
                          [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}"
                          >
             </yt-multiselect>
             <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
              <span *ngFor="let validation of errorMessages.KomitentID">
                <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)">
                  <span [ngClass]="{'slideInRight': fc.KomitentID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
                </span>
              </span>
            </div>
          </div>
    </div>
</form>
